import client from "utils/api";

function changeToken(token,id){
  return client().post(`/users/facebook/token`,{token, id})
    .then((response) => {
      return response.data
    })
    .catch(err=>{})

}

export default {
  changeToken
}



// WEBPACK FOOTER //
// ./src/components/shared/facebook/api.js